export default __webpack_public_path__ + "static/media/select-inquiry-gray.28bcaf0d.svg";